var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRegionsBank = function SvgRegionsBank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "regions-bank_svg__Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".regions-bank_svg__st1{fill:#fff}")), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#81b83e"
    },
    d: "M0 0h40v40H0z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "regions-bank_svg__Calque_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "regions-bank_svg___x33_",
    className: "regions-bank_svg__st1",
    d: "m4 18.3 2-2.6 1.2 2.6H4zm2.1-2.7 1-1.3.5 3.9-1.5-2.6zM8 13.3l.8.9-.8 4-.8-4 .8-.9zm.3 5 .5-4 1 1.3-1.5 2.7zm.3 0 1.2-2.6 2 2.6H8.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "regions-bank_svg___x32_",
    transform: "translate(47 7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "regions-bank_svg__R",
    className: "regions-bank_svg__st1",
    d: "M-39.4 15.1c.9.1 1.4-.2 1.4-1 0-.6-.4-.9-1-.9h-.4v1.9m-1.1-1.4c0-.4-.1-.6-.7-.7v-.1h2.4c1.4 0 2 .6 2 1.2 0 .5-.3.9-1 1.1.6.1 1.1 1.6 1.6 2.1.1.1.3.2.5.2v.1h-1.5c-.6-.7-.9-1.7-1.3-2.1-.2-.2-.4-.2-.8-.2v1.5c0 .4.2.6.7.7v.1H-41v-.1c.5 0 .7-.2.7-.6v-3.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "regions-bank_svg__E",
    className: "regions-bank_svg__st1",
    d: "M-32.3 16.4c-.2-.3-.3-.5-.7-.5h-.7v1c0 .4.2.5.6.5h.2c.5 0 .8-.4.8-.7h.1l-.1.8h-3v-.1c.5-.1.5-.2.5-.6v-2.3c0-.3-.1-.5-.5-.5v-.1h3v.8h-.1c-.1-.5-.3-.6-.8-.6h-.8v1.5h.7c.3 0 .5-.1.6-.5h.1l.1 1.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "regions-bank_svg__G",
    className: "regions-bank_svg__st1",
    d: "M-27.6 17.4c-.4.2-.9.3-1.5.3-1.4 0-2.2-.9-2.2-1.9 0-1.1.9-2 2.2-2 .6 0 .8.2 1.1.2.1 0 .2 0 .3-.1h.1v1h-.1c-.3-.6-.8-.9-1.3-.9-.8 0-1.2.7-1.2 1.8s.6 1.6 1.3 1.6c.4 0 .6-.1.6-.4v-.6c0-.3-.1-.4-.4-.5v-.1h1.7v.2c-.3.1-.4.2-.4.6l-.2.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "regions-bank_svg__I",
    className: "regions-bank_svg__st1",
    d: "M-25 17c0 .3.1.4.5.5v.2h-1.9v-.1c.4-.2.4-.3.4-.6v-2.3c0-.3-.1-.4-.5-.5v-.1h1.9v.1c-.5.1-.5.3-.5.6V17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "regions-bank_svg__O",
    className: "regions-bank_svg__st1",
    d: "M-21.5 14.1c-.8 0-1.2.6-1.2 1.8 0 .8.3 1.7 1.2 1.7.7 0 1.2-.5 1.2-1.7.1-1.1-.3-1.8-1.2-1.8m0 3.6c-1.2 0-2.2-.8-2.2-1.9s.9-2 2.2-2 2.2.8 2.2 2c0 1.1-.9 1.9-2.2 1.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "regions-bank_svg__N",
    className: "regions-bank_svg__st1",
    d: "m-14.9 17.6-2.9-3v2.3c0 .4.1.5.6.6v.2h-1.4v-.1c.5-.1.6-.3.6-.7v-2.4c-.3-.3-.4-.4-.6-.4V14h1.2l2.3 2.4v-1.6c0-.5-.1-.7-.5-.7V14h1.3v.1c-.5 0-.6.3-.6.6v2.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "regions-bank_svg__S",
    className: "regions-bank_svg__st1",
    d: "M-11.2 14.8c-.3-.5-.7-.8-1-.8s-.7.2-.7.5c0 .1.1.3.2.4.2.2 1.1.7 1.3.8.3.3.5.6.5.8 0 .8-.8 1-1.3 1s-.8-.2-.9-.2c-.1 0-.2 0-.2.1h-.1v-1.1h.1c.1.6.5.9 1 .9s.8-.2.8-.6c0-.1-.1-.3-.2-.4-.3-.3-1-.6-1.3-.8s-.4-.5-.4-.8c0-.7.5-1 1.2-1h.4c.1 0 .3.1.4.1.1 0 .1 0 .2-.1h.1l-.1 1.2"
  })))));
};
export default SvgRegionsBank;